import styles from "./App.module.css";
import { Routes, Route, useNavigate, useParams } from "react-router-dom";
import DataContext, { DataProvider } from "./context/DataContext";
import { AuthProvider } from "./context/AuthContext";
import NavBar from "./components/nav_bar/NavBar";
import Footer from "./components/footer/Footer";
import Home from "./pages/home/Home";
import NotFound from "./pages/not_found/NotFound";

import Search from "./pages/search/Search";
import Result from "./pages/result/Result";
import Customization from "./pages/customization/Customization";
import { useContext, useEffect, useRef, useState } from "react";
import RedirectToExternal from "./components/ui/redirect_to_external/RedirectToExternal";
import I18nProvider from "./I18nProvider";
import PosLogin from "./pages/pos/login/PosLogin";
import PosTicketSearch from "./pages/pos/search_tickets/PosTicketSearch";
import PrivateRoute from "./PrivateRoute";
import PosPermitSearch from "./pages/pos/search_permits/PosPermitSearch";
import Unauthorized from "./pages/pos/unauthorized/Unauthorized";
import { POSDataProvider } from "./context/POSDataContext";
import useHomePath from "./hooks/useHomePath";
import PosServices from "./pages/pos/pos_services/PosServices";
import PosTicketResult from "./pages/pos/result_tickets/PosTicketResult";
import PosShoppingCart from "./pages/pos/shopping_cart/PosShoppingCart";
import PosSummary from "./pages/pos/summary/PosSummary";
import PosResult from "./pages/pos/result/PosResult";
import PosCashOp from "./pages/pos/cash_operations/PosCashOp";

import TermsDisclaimer from "./pages/term_disclaimer/TermsDisclaimer";
/**
 * App.js
 * The rerouting is controlled by the PrivateRoute component
 */
function App() {
    const { isRedirecting } = useContext(DataContext);

    return (
        !isRedirecting && (
            <div className={`${styles.App}`}>
                <DataProvider>
                    <I18nProvider>
                        <AuthProvider>
                            <POSDataProvider>
                                <NavBar />
                                <Routes>
                                    <Route
                                        path="/"
                                        element={
                                            <RedirectToExternal
                                                path={
                                                    "https://www.schweers.com"
                                                }
                                            />
                                        }
                                    />
                                    <Route path="/:bUser" element={<Home />} />
                                    <Route
                                        path="/:bUser/terms"
                                        element={
                                            <TermsDisclaimer
                                                header={"terms and conditions"}
                                                contentName={"termsContent"}
                                            />
                                        }
                                    />
                                    <Route
                                        path="/:bUser/disclaimer"
                                        element={
                                            <TermsDisclaimer
                                                header={"disclaimer"}
                                                contentName={
                                                    "disclaimerContent"
                                                }
                                            />
                                        }
                                    />
                                    <Route
                                        path="/:bUser/search"
                                        element={<Search />}
                                    />
                                    <Route
                                        path="/:bUser/result"
                                        element={<Result />}
                                    />
                                    <Route
                                        path="/:bUser/customization"
                                        element={<Customization />}
                                    />
                                    <Route
                                        path="/:bUser/pos"
                                        element={<PosLogin />}
                                    />

                                    <Route
                                        path="/:bUser/pos/tickets"
                                        element={
                                            <PrivateRoute
                                                allowedRoles={[
                                                    "cashier",
                                                    "supervisor",
                                                ]}
                                            >
                                                <PosTicketSearch />
                                            </PrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="/:bUser/pos/tickets/result"
                                        element={
                                            <PrivateRoute
                                                allowedRoles={[
                                                    "cashier",
                                                    "supervisor",
                                                ]}
                                            >
                                                <PosTicketResult />
                                            </PrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="/:bUser/pos/permits"
                                        element={
                                            <PrivateRoute
                                                allowedRoles={[
                                                    "cashier",
                                                    "supervisor",
                                                ]}
                                            >
                                                <PosPermitSearch />
                                            </PrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="/:bUser/pos/services"
                                        element={
                                            <PrivateRoute
                                                allowedRoles={[
                                                    "cashier",
                                                    "supervisor",
                                                ]}
                                            >
                                                <PosServices />
                                            </PrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="/:bUser/pos/shopping-cart"
                                        element={
                                            <PrivateRoute
                                                allowedRoles={[
                                                    "cashier",
                                                    "supervisor",
                                                ]}
                                            >
                                                <PosShoppingCart />
                                            </PrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="/:bUser/pos/result"
                                        element={
                                            <PrivateRoute
                                                allowedRoles={[
                                                    "cashier",
                                                    "supervisor",
                                                ]}
                                            >
                                                <PosResult />
                                            </PrivateRoute>
                                        }
                                    />

                                    <Route
                                        path="/:bUser/pos/summary"
                                        element={
                                            <PrivateRoute
                                                allowedRoles={[
                                                    "cashier",
                                                    "supervisor",
                                                ]}
                                            >
                                                <PosSummary />
                                            </PrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="/:bUser/pos/cash-operations"
                                        element={
                                            <PrivateRoute
                                                allowedRoles={[
                                                    "cashier",
                                                    "supervisor",
                                                ]}
                                            >
                                                <PosCashOp />
                                            </PrivateRoute>
                                        }
                                    />
                                    <Route
                                        path="/:bUser/pos/customization"
                                        element={<Customization />}
                                    />

                                    <Route
                                        path="/:bUser/pos/unauthorized"
                                        element={<Unauthorized />}
                                    />
                                    <Route
                                        path=":bUser/*"
                                        element={<NotFound />}
                                    />
                                    {/* <Route path="/404" element={<NotFound />} /> */}
                                    {/* <Route path="*" element={<NotFound />} /> */}
                                </Routes>
                                <Footer />
                            </POSDataProvider>
                        </AuthProvider>
                    </I18nProvider>
                </DataProvider>
            </div>
        )
    );
}

export default App;
